@if (customObjectValue) {
  <div class="header">
    <div class="header__left">
      <a class="breadcrumb" [routerLink]="['../../', customObjectValue.customObject.id]">
        {{ customObjectValue.customObject.label }}
      </a>
      / {{ faceValue() }}
    </div>
    <div class="header__center">
      <a routerLink="./details" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">Details</a>
      <a routerLink="./folders" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">Files</a>
      <a
        routerLink="new-tasks/CustomObjectValue/{{ customObjectValue.id }}"
        [routerLinkActive]="['active']"
        [routerLinkActiveOptions]="{ exact: false }"
        >Tasks<span class="badge" *ngIf="customObjectValue.num_open_tasks && customObjectValue.num_open_tasks > 0">{{
          customObjectValue.num_open_tasks
        }}</span></a
      >
      <a routerLink="./notes" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: false }">Notes</a>

      @for (linkedCustomObject of linkedCustomObjects(); track linkedCustomObject.id) {
        <a
          [routerLink]="['link', linkedCustomObject.id]"
          [queryParams]="{ related_to_type: customObjectValue.customObject.name, related_to_id: customObjectValue.id }"
          [routerLinkActive]="['active']"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          {{ linkedCustomObject.label }}
        </a>
      }
    </div>
    <div class="header__right">
      <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
        <mat-icon svgIcon="more_vert"></mat-icon>
      </button>
      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="openGenerateModal()">
          <mat-icon [svgIcon]="'description'"></mat-icon>
          Generate Merge Document
        </button>
        <button
          mat-menu-item
          (click)="changeLayout.emit()"
          [appAuthorize]="canEditLayout(customObjectValue.customObject.name)"
        >
          <mat-icon svgIcon="sync_alt"></mat-icon>
          <span>Change Layout</span>
        </button>
        <button
          mat-menu-item
          (click)="duplicate.emit()"
          denyAction="disable"
        >
          <mat-icon svgIcon="difference"></mat-icon>
          Duplicate
        </button>
      </mat-menu>
    </div>
  </div>
}
